export const BASE_CLASS = 'mt-MediaSize'
export const BASE_CLASS_RULER = `${BASE_CLASS}-ruler`
